import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { faEllipsis, faEnvelope, faFilter, faPhone, faRotateRight, faSearch, faSms, faSortAmountDownAlt, faSortDown, faSortUp, faTrash, faUser } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbPopover, NgbTypeahead, NgbTypeaheadSelectItemEvent, NgbDropdown, NgbDropdownToggle, NgbTooltip, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { SendSmsDialogComponent } from '../send-sms-dialog/send-sms-dialog.component';
import { CallDialerDialogComponent } from '../call-dialer-dialog/call-dialer-dialog.component';
import { Observable, Subject, debounceTime, distinctUntilChanged, filter, map, merge, takeUntil } from 'rxjs';
import { ConversationService } from 'src/app/conversation.service';
import { SendEmailComponent } from 'src/app/send-email/send-email.component';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/alert.service';
import { CallService } from 'src/app/call.service';
import { TwilioService } from 'src/app/twilio.service';
import { SmsCallService } from 'src/app/sms-call/sms-call.service';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-conversation-list',
    templateUrl: './conversation-list.component.html',
    styleUrls: ['./conversation-list.component.css'],
    imports: [FaIconComponent, ReactiveFormsModule, FormsModule, NgIf, NgFor, NgClass, NgbPopover, NgbDropdown, NgbDropdownToggle, NgbTooltip, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbCollapse, RouterLink, DatePipe]
})
export class ConversationListComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() conversationList: any[];
  @Input() isLoading: boolean = false;
  @Output() selectConversation = new EventEmitter();
  @Output() refreshConversation = new EventEmitter();
  @Output() searchSelect = new EventEmitter();
  @Output() fetchUserChats = new EventEmitter();
  @Output() triggerTotalCount = new EventEmitter();

  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  @ViewChild('instance') instance: NgbTypeahead;

  searchContact: any = null;
  componentDestroyed$: Subject<boolean> = new Subject()

  subs = new Subscription()
  twilioDevice: any;
  twilioClient: any;
  chatList: any[] = [];
  currentConversation: any;
  messages: any[] = [];
  isTyping: boolean;
  currentUserNumber = '+14782177074'; // TODO remove mock data
  // newUser = 'zack@elvesandladders.com'
  userName = 'GHL'

  conversationListFiltered: any[] = []
  defaultConversationListFiltered: any[] = []
  selectedId: string = null;
  sortBy = "createdAt"
  sortDirection: string = 'DESC';
  limit: number = null;
  selectedFilters: any[] = [];
  columnFilterValues = new Map<any, any>([
    ["status", [
      { name: "In Review", value: "OPEN" },
      { name: "More Info Needed", value: "REQUEST INFO" },
      { name: "In Progress", value: "IN PROGRESS" },
      { name: "Follow Up", value: "FOLLOW UP" },
      { name: "Completed", value: "CLOSE" },
    ]],
  ]);

  activeFilters = new Map();
  activeFilterCount: number = 0;
  isMobileDevice: boolean = /Mobi/i.test(window.navigator.userAgent);
  screenSize = window.screen.availWidth;
  activePopOver: NgbPopover;

  faFilter = faFilter;
  faSortAmountDownAlt = faSortAmountDownAlt;
  faRotateRight = faRotateRight;
  faPhone = faPhone;
  faSms = faSms;
  faEllipsis = faEllipsis;
  faTrash = faTrash;
  faSortDown = faSortDown;
  faSortUp = faSortUp;
  faSearch = faSearch;
  faUser = faUser;
  faEnvelope = faEnvelope;

  statuses: any[] = [
    { name: "In Review", value: "OPEN" },
    { name: "In Review", value: "CONSIDERING" },
    { name: "More Info Needed", value: "REQUEST INFO" },
    { name: "In Progress", value: "IN PROGRESS" },
    { name: "Follow Up", value: "FOLLOW UP" },
    { name: "Completed", value: "CLOSE" },
  ]

  constructor(
    private modalService: NgbModal,
    private conversationSerivce: ConversationService,
    private alertService: AlertService,
    private smsCallService: SmsCallService,
    private callService: CallService,
    private twilioService: TwilioService,
  ) { }

  ngOnInit(): void {
    this.conversationSerivce.twilioClient
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((data) => {
        this.twilioClient = data;
      });

    this.callService.twilioDevice
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((data) => {
        this.twilioDevice = data;
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.conversationList) {
      if (changes.conversationList.currentValue) {
        this.conversationListFiltered = [...this.conversationList];

        this.defaultConversationListFiltered = [...this.conversationList];

        this.countUnread()
      }
    }
  }

  ngAfterViewInit() {
    if(this.conversationListFiltered && this.conversationListFiltered.length != 0 && !this.selectedId) {
      this.setSelectedConversation(this.conversationListFiltered[0])
    }
  }

  // getActiveUsers() {
  //   this.twilioClient.getSubscribedUsers().then(users => {

  //   })
  // }

  newChat() {
    this.isLoading = true;
    this.twilioClient.getUser(this.currentUserNumber).then(res => {
      if (res) {
        this.openSmsDialog()
      }
    }).catch(err => {
      this.isLoading = false;
      this.alertService.showWarningAlert('User not found in Twilio');
    });
  }


  setSelectedConversation(selectedConverstaion) {
    if (this.conversationList && this.conversationList.length != 0) {
      this.selectedId = selectedConverstaion.id;
      this.selectConversation.emit(selectedConverstaion)
    }
  }

  getDistinctColumnValues(column: string): void {
    let tempArray = [];
    let statuses = [...new Set(this.conversationList.map(item => item[column]))];

    statuses.forEach((item, i) => {
      tempArray.push({
        name: this.renameStatuses(item),
        value: item
      })
    })

    this.columnFilterValues.set(column, tempArray);

  }

  renameStatuses(value: any): string {
    return this.statuses.find(o => o.value.toLowerCase() === value.toLowerCase()).name;
  }

  addRemoveFilter(column: string, value: string): void {

    const index = this.selectedFilters.findIndex((o) => o.value === value);
    if (index < 0) {
      this.selectedFilters.push({ column: column, value: value });
    } else {
      this.selectedFilters.splice(index, 1);
    }
    this.filterArray();
  }

  filterArray() {
    let myArrayFiltered: any[] = [];
    if (this.selectedFilters.length > 0) {
      myArrayFiltered = this.conversationList.filter((el) => {
        return this.selectedFilters.some((filter) => {
          return el.status == filter.value;
        });
      });
    } else {
      myArrayFiltered = this.conversationList;
    }

    this.conversationListFiltered = myArrayFiltered;
  }

  setSort(column: string): void {
    if (column != this.sortBy) this.sortDirection = 'ASC';
    if (column == this.sortBy) this.sortDirection = (this.sortDirection == 'ASC') ? 'DESC' : 'ASC';
    this.sortBy = column;

    this.sortConversationList();
  }

  sortConversationList() {
    let sortedArray: any[] = []

    if (this.sortDirection === 'ASC') {
      sortedArray = this.conversationList.sort((d1, d2) => new Date(d1.createdAt).getTime() - new Date(d2.createdAt).getTime());
    } else {
      sortedArray = this.conversationList.sort((d1, d2) => new Date(d2.createdAt).getTime() - new Date(d1.createdAt).getTime());
    }

    this.conversationListFiltered = sortedArray;
  }

  deleteConversation(conversationId: string, contactId: string) {
    // TODO add logs to DB
    // TODO add alert permanently delete
    this.conversationSerivce.deleteConversation(conversationId, contactId)
      .pipe().subscribe(res => {
        if (res) {
          // this.conversationListFiltered = this.conversationListFiltered.filter(convo => convo.id != conversationId)
          // this.setSelectedConversation(this.conversationListFiltered[0])
          this.alertService.showSuccessAlert('Conversation Deleted');
          this.fetchUserChats.emit()
        }
      })
  }

  resetActiveFilters(): void {
    this.selectedFilters = [];
    this.filterArray();
    this.sortConversationList();
  }

  checkIfSelected(value: any): boolean {
    let a = this.selectedFilters.some(filter => filter['value'] == value);
    return a;
  }

  refreshConversations() {
    this.selectedFilters = [];
    this.sortDirection = 'DESC';
    this.refreshConversation.emit(this);
    this.fetchUserChats.emit()
  }

  openSmsDialog(): void {
    const modalRef = this.modalService.open(SendSmsDialogComponent);
    modalRef.componentInstance.twilioClient = this.twilioClient
    modalRef.componentInstance.sent.subscribe((res) => {
      this.fetchUserChats.emit();
      this.isLoading = false
      this.alertService.showSuccessAlert('Message sent');
    });
  }

  openCallDialerDialog(contact?: any): void {
    this.activePopOver?.close();
    const modalRef = this.modalService.open(CallDialerDialogComponent, { windowClass: "callDialerDialog" });
    modalRef.componentInstance.passedContact = contact;

    modalRef.componentInstance.call.subscribe((data) => {
      this.openInCallDialog(data);
    });
  }

  async openInCallDialog(data: any) {
    const phoneNumber = data.number.replace(/\D/g, '')
    const formattedNumber = Number(phoneNumber)
    // TODO direct call
    const outGoingCall = await this.twilioDevice.connect({
      params: { To: `+1${formattedNumber}`, 'contactId': data.contact ? data.contact.id : null }
    });
    this.twilioService.outgoingConnection = outGoingCall
  }


  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => this.instance && !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.conversationListFiltered
          : this.conversationListFiltered.filter(v =>  String(v['clientNumber'] || v['phone'])?.toLowerCase().indexOf(term?.toLowerCase()) > -1 || v['name'].toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10)
    ));
  }

  formatter = (result: any) => `${result.name} - ${result.clientNumber || result.phone}`;

  searchContacts(searchText: string) {
    let conversationList = this.defaultConversationListFiltered;
    this.conversationListFiltered = conversationList.filter(v =>  String(v['clientNumber'] || v['phone'])?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1 || v['name'].toLowerCase().indexOf(searchText.toLowerCase()) > -1);

  }


  selectContact(event: NgbTypeaheadSelectItemEvent): void {
    if (event) event.preventDefault();
    this.searchContact = event.item?.name;
    this.selectedId = event.item?.id;
    this.selectConversation.emit(event.item)
  }

  popOverOptions(popover: NgbPopover, contact: any): void {

    if (popover.isOpen()){
      popover.close();
    } else {
      this.conversationSerivce.getContactByNumber(`+1${contact.clientNumber}`).subscribe(res => {
        this.activePopOver = popover;
        popover.open({ popover, res });
      })
    }
  }

  openEmailDialog(contact): void {
    this.activePopOver?.close();
    const modalRef = this.modalService.open(SendEmailComponent);
    if (contact) {
      modalRef.componentInstance.clientId = contact.clientId;
    }
    modalRef.componentInstance.type = 'GENERAL';
    //modalRef.componentInstance.toEmailAddresses = [contact.email];
  }

  countUnreadMessages(conversation: any) {
    const lastMessageIndex = conversation?.chat?.lastMessage?.index;
    let count = lastMessageIndex - (conversation?.chat?.lastReadMessageIndex !== null ? conversation?.chat?.lastReadMessageIndex : -1)
    this.countUnread();
    return count ? count : 0;
  }

  countUnread(){
    let count = 0;
    this.conversationListFiltered.forEach(conversation => {
      const lastMessageIndex = conversation?.chat?.lastMessage?.index;
      count = count + (lastMessageIndex - (conversation?.chat?.lastReadMessageIndex !== null ? conversation?.chat?.lastReadMessageIndex : -1));
    });

    this.triggerTotalCount.emit(count)
  }

  formatPhoneNumber(phoneNumberString) {
    let formattedNumber = null;
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      formattedNumber = '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return formattedNumber;
  }
}
